export default __webpack_public_path__ + "static/media/LV.2fb016af.svg";